<template>
  <div class="api-key-item-tag-row">
    <span class="api-key-item-tag-row__label">{{ label }}</span>
    <div class="api-key-item-tag-row__tags">
      <BittsTag
        v-if="!items.length"
        :text="fallback"
        :color="fallbackColor"
        size="x-small"
      />
      <BittsTag
        v-for="item in items"
        :key="item"
        :text="item"
        :color="color"
        size="x-small"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsTag } from '@crossbeam/bitts';

const {
  label,
  items,
  fallback,
  color = 'neutral',
  fallbackColor = 'neutral',
} = defineProps<{
  label: string;
  items: string[];
  fallback: string;
  color?: string;
  fallbackColor?: string;
}>();
</script>

<style scoped lang="pcss">
@reference "../css/theme.css";
.api-key-item-tag-row {
  @apply flex items-start gap-12;
}

.api-key-item-tag-row__label {
  @apply text-xs font-medium uppercase tracking-wide text-neutral-text-weak
    shrink-0 w-[60px] pt-4;
}

.api-key-item-tag-row__tags {
  @apply flex flex-wrap gap-4 font-mono flex-1 min-w-0;
}
</style>
